module.exports = __webpack_public_path__ + "assets/img/ic-rocket.b4979112.svg";